/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Client module `index` for the Caintra Connect frontend.
 * @module modals/ViewB2BRegistrationModal/index
 *
 * Conventions:
 * - Keep components focused on rendering; move branching logic into hooks or utils.
 * - Prefer named exports for helpers and default exports for React components.
 * - Reuse shared validation, i18n, and API helpers from client/src/utils and logic/.
 */
import CloseIcon from "@mui/icons-material/Close";

import ViewB2BRegistrationContent from "../../components/ViewB2BRegistrationContent/index.jsx";
import styles from "./index.module.css";

/**
 * Modal that shows B2B event registration details and a QR code for check-in.
 * QR encodes { userId, idEventoB2B, idCita } for the attendance confirm API.
 */
const ViewB2BRegistrationModal = ({ open, onClose, event, appointment }) => {
  if (!open) {
    return null;
  }

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <button className={styles.closeButton} onClick={onClose} type="button">
          <CloseIcon />
        </button>

        <ViewB2BRegistrationContent
          event={event}
          appointment={appointment}
          variant="modal"
        />
      </div>
    </div>
  );
};

export default ViewB2BRegistrationModal;
